/**
 * Template keys for bank statement (izvod) rows shown in the Goods & Material
 * preview of 5D statements. Like every other template key, the user enters
 * the output column / XML attribute name for each key in the template editor;
 * the label below is only the default shown when nothing was entered.
 *
 * The three "– izvod" keys are the values the user assigns per row (directly
 * or through posting rules) and that get written into the downloaded IZ/PR
 * XML as attributes named after the configured title.
 */
export const BANK_STATEMENT_FIELD_LABELS: { [key: string]: string } = {
  bankKonto: 'Konto linije – izvod',
  bankIdBroj: 'ID broj – izvod',
  bankSifraPartnera: 'Sifra partnera – izvod',
  bankOpis1: 'Opis_1',
  bankOpis2: 'Opis_2',
  bankSvrhaDoznake: 'Svrha doznake',
  bankDuguje: 'Duguje',
  bankPotrazuje: 'Potrazuje',
  bankUseCash: 'U gotovu',
  bankSyncToEPO: 'Sync Ostalo to EPO/KP',
};

export const BANK_STATEMENT_FIELDS: string[] = Object.keys(BANK_STATEMENT_FIELD_LABELS);

/**
 * The two per-row checkboxes of 5D statements. They are template toggles like
 * every other column, but render as checkbox columns, not as value cells.
 */
export const BANK_STATEMENT_CHECKBOX_FIELDS: string[] = ['bankUseCash', 'bankSyncToEPO'];

/** Value columns of the Goods & Material table (everything except the checkboxes). */
export const BANK_STATEMENT_COLUMN_FIELDS: string[] = BANK_STATEMENT_FIELDS.filter(
  (key) => !BANK_STATEMENT_CHECKBOX_FIELDS.includes(key)
);

/** Keys the user assigns (rules / autocompletes) and that go into the XML. */
export const BANK_STATEMENT_XML_FIELDS: string[] = ['bankKonto', 'bankIdBroj', 'bankSifraPartnera'];

/** Attribute names used when a template has no name configured for a key. */
export const BANK_STATEMENT_XML_FALLBACK_ATTRS: { [key: string]: string } = {
  bankKonto: 'KONTO',
  bankIdBroj: 'IDBROJ',
  bankSifraPartnera: 'SIFRA_PARTNERA',
};

/** `{ key: value }` for every bank statement key (template editor toggles/titles). */
export function bankStatementFieldMap<T>(value: T): { [key: string]: T } {
  return BANK_STATEMENT_FIELDS.reduce((acc, key) => {
    acc[key] = value;
    return acc;
  }, {} as { [key: string]: T });
}

export function isBankStatementField(key: string): boolean {
  return Object.prototype.hasOwnProperty.call(BANK_STATEMENT_FIELD_LABELS, key);
}
